// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyAt75KYe456Ov8NFI4f4fdi6M3LcUQdzIE",
    authDomain: "my-chating-room.firebaseapp.com",
    databaseURL: "https://my-chating-room.firebaseio.com",
    projectId: "my-chating-room",
    storageBucket: "my-chating-room.appspot.com",
    messagingSenderId: "275564054658",
    appId: "1:275564054658:web:d501988c993fdf3de44c9b",
    measurementId: "G-LX1GW80WF4"
  };

  const firebaseApp= firebase.initializeApp
  (firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  
  export {auth, provider};
  export default db;